export default "__VITE_ASSET__BLv3e0ja__"